import React, { useContext } from "react";

import MainLayout from '../layouts/MainLayout'
import UserInfos from '../components/UserInfos'
import { AuthContext } from '../services/Session/Context'
import Widget from "../components/Widget";

const Dashboard = () => {
  const { user } = useContext(AuthContext)

  return (
    <MainLayout>
      <div className="flex">
        <div className="flex-1">
          <h1 className="text-4xl font-semibold text-gray-800">Bienvenue, <span className="capitalize">{user.firstName}</span></h1>
          <h2 className=" text-gray-400">Voici ce qui se passe dans votre organisation.</h2>
        </div>
        <UserInfos/>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 my-6">
        <Widget title='N/A'/>
        <Widget title='N/A'/>
        <Widget title='N/A'/>
        <Widget title='N/A'/>
      </div>
    </MainLayout>
  ) 
}

export default Dashboard